const FINGERPRINT_STORAGE_KEY = 'applicator_device_fp_v1'

function bytesToHex(bytes: ArrayBuffer): string {
  return Array.from(new Uint8Array(bytes))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export async function computeDeviceFingerprint(): Promise<string | null> {
  if (typeof window === 'undefined' || !globalThis.crypto?.subtle) {
    return null
  }

  const payload = {
    ua: navigator.userAgent,
    lang: navigator.language,
    langs: navigator.languages?.join(',') ?? '',
    screen: `${screen.width}x${screen.height}@${window.devicePixelRatio}`,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hc: navigator.hardwareConcurrency ?? 0,
  }

  const encoded = new TextEncoder().encode(JSON.stringify(payload))
  const digest = await crypto.subtle.digest('SHA-256', encoded)
  return bytesToHex(digest)
}

export async function getDeviceFingerprint(): Promise<string | null> {
  if (typeof window === 'undefined') return null

  try {
    const stored = sessionStorage.getItem(FINGERPRINT_STORAGE_KEY)
    if (stored && /^[a-f0-9]{64}$/.test(stored)) {
      return stored
    }
  } catch {
    // sessionStorage may be unavailable in strict privacy mode
  }

  const computed = await computeDeviceFingerprint()
  if (!computed) return null

  try {
    sessionStorage.setItem(FINGERPRINT_STORAGE_KEY, computed)
  } catch {
    // ignore
  }

  return computed
}
